export function getAveragesFromEntries(entries) {
  return entries.map(([degreeCount, instCount, y]) => [[degreeCount], [instCount]]).reduce((acc, el) => [
    [...acc[0], ...el[0]],
    [...acc[1], ...el[1]]
  ], [[], []]).map((opts) => Math.max(...opts));
}
export const getNationalCounts = (allData) => {
  return allData.map(reduceAnnualData).map((data) => separateByDegreeType(data)).reduce(combineArrayTriplets, [[], [], []]).map((degreeTypeCollection) => Object.entries(degreeTypeCollection.map(([degree, data]) => ({
    [degree]: data
  })).reduce(collectReducedRecords, {})).map(([id, dataList]) => {
    const avg = getAverageRecentPhysicsDegrees(dataList);
    return avg > 0 ? {
      [Math.floor(avg)]: [id]
    } : {};
  }).reduce(collectDegreeCounts, {})).map(tripletToNationalCount).reduce(combineNationalCountObjects, {
    Bachelors: {},
    Masters: {},
    Doctorate: {}
  });
};
const reduceAnnualData = (data) => ({
  id: data.id,
  ficeCode: data.ficeCode,
  degreeType: data.degreeType,
  physicsDegreeCount: data.physicsDegreeCount,
  year: data.year
});
const separateByDegreeType = (data) => data.degreeType === "Bachelors" ? [[[data.ficeCode, [data]]], [["", []]], [["", []]]] : data.degreeType === "Masters" ? [[["", []]], [[data.ficeCode, [data]]], [["", []]]] : [[["", []]], [["", []]], [[data.ficeCode, [data]]]];
function combineArrayTriplets(acc, el) {
  return [
    [...el[0], ...acc[0]],
    [...el[1], ...acc[1]],
    [...el[2], ...acc[2]]
  ];
}
const collectReducedRecords = (acc, el) => {
  const [elId, elData] = Object.entries(el)[0];
  return elData.length ? Object.prototype.hasOwnProperty.call(acc, elId) ? {...acc, [elId]: [...acc[elId], ...elData]} : {...acc, [elId]: elData} : acc;
};
const getAverageRecentPhysicsDegrees = (data) => [...data].sort((a, b) => b.year - a.year).slice(0, 3).map((d) => d.physicsDegreeCount).reduce((acc, el) => acc + el, 0) / data.slice(0, 3).length;
const collectDegreeCounts = (acc, el) => {
  if (!Object.entries(el).length)
    return acc;
  const [count, ids] = Object.entries(el)[0];
  return Object.prototype.hasOwnProperty.call(acc, count) ? {
    ...acc,
    [count]: [...acc[parseInt(count)], ...ids]
  } : {...acc, [count]: ids};
};
const tripletToNationalCount = (el, i) => i === 0 ? {Bachelors: el, Masters: {}, Doctorate: {}} : i === 1 ? {Bachelors: {}, Masters: el, Doctorate: {}} : {Bachelors: {}, Masters: {}, Doctorate: el};
const combineNationalCountObjects = (acc, el) => ({
  Bachelors: {...acc.Bachelors, ...el.Bachelors},
  Masters: {...acc.Masters, ...el.Masters},
  Doctorate: {...acc.Doctorate, ...el.Doctorate}
});
export const getTextDegree = (degreeType) => degreeType === "Doctorate" ? degreeType : degreeType.slice(0, degreeType.length - 1) + "'s";
export const getRecentAnnualDataAverages = (recentData) => {
  return {
    degreeType: recentData[0].degreeType || "Bachelors",
    allDegreeCount: getAverage(recentData.map((obj) => obj.allDegreeCount)),
    stemDegreeCount: getAverage(recentData.map((obj) => obj.stemDegreeCount)),
    physicsDegreeCount: getAverage(recentData.map((obj) => obj.physicsDegreeCount)),
    domesticStudentPhysicsDegreeCount: getAverage(recentData.map((obj) => obj.domesticStudentPhysicsDegreeCount)),
    womenPhysicsDegreeCount: getAverage(recentData.map((obj) => obj.womenPhysicsDegreeCount)),
    blackPhysicsDegreeCount: getAverage(recentData.map((obj) => obj.blackPhysicsDegreeCount)),
    hispanicPhysicsDegreeCount: getAverage(recentData.map((obj) => obj.hispanicPhysicsDegreeCount)),
    nativeAmericanPhysicsDegreeCount: getAverage(recentData.map((obj) => obj.nativeAmericanPhysicsDegreeCount)),
    domesticURMPhysicsDegreeCount: getAverage(recentData.map((obj) => obj.domesticURMPhysicsDegreeCount))
  };
};
export const getAverage = (array) => {
  return array.reduce((acc, el) => acc + el, 0) / array.length;
};
export const getNatlAvgStat = (averages, degreeType, idx) => {
  const pertinantArr = degreeType === "Bachelors" ? [
    "physBac_outof_allBac",
    "physBac_outof_STEMBac",
    "femPhysBac_outof_allPhysBac",
    "URMPhysBac_outof_USPhysBac"
  ] : degreeType === "Masters" ? [
    "physMas_outof_allMas",
    "physMas_outof_STEMMas",
    "femPhysMas_outof_allPhysMas",
    "URMPhysMas_outof_USPhysMas"
  ] : [
    "physDoc_outof_allDoc",
    "physDoc_outof_STEMDoc",
    "femPhysDoc_outof_allPhysDoc",
    "URMPhysDoc_outof_USPhysDoc"
  ];
  return averages.filter((avg) => avg.title === pertinantArr[idx])[0].percentage || 0;
};
export const shouldIncludeDegreeData = (institution) => (degreeType) => institution.degreesAwarded.filter((d) => d.degreeType === degreeType).map((d) => Boolean(+d.physicsDegreeCount)).reduce((acc, el) => acc || el, false);
